import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import clipText from '../../../../../utils/clipText';
import { formatCommentEmoji } from '../../../../../utils/format';
import { getEscapeComment, getBrComment } from '../../../../../utils';
import styles from './index.css';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import emoji from '../../../../../utils/emoji';

const Text = ({ content }) => {
    const { comment_contents, wrapClass, addonClass, pid, isVideoShare } = content;

    const ellipsis = '...';
    const comment = getEscapeComment(comment_contents);

    const [text, setText] = useState(comment);
    const [overflow, setOverflow] = useState(true);
    const [overflowLoading, setOverflowLoading] = useState(true);

    const wrapRef = useRef();
    const addonRef = useRef();

    useEffect(() => {
        const docWidth = Math.min(window?.__IFENG_ENV__?.maxDocWidth || 812, window.innerWidth);

        const emojiWidth = (37.5 * docWidth) / 750;

        const { text: textClip, overflow } = clipText({
            content: comment,
            line: 10,
            ellipsis,
            addonDom: addonRef.current,
            wrapDom: wrapRef.current,
            emoji,
            emojiWidth,
        });

        const text = formatCommentEmoji(getBrComment(textClip));

        setText(text);
        setOverflow(overflow);
        setOverflowLoading(false);
    }, []);

    const handleMoreClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1525891421430',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8979',
              };
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid,
                kind: 'inter_fxy17',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                noKindFrom: 1,
            });
        }
    };

    const schemeLink = getSchemeLink({
        docType: 'phvideo',
        pid,
        kind: 'inter_fxy17',
        noKindFrom: 1,
    });

    return (
        <div className={wrapClass}>
            <div className={styles.text} ref={wrapRef}>
                <span dangerouslySetInnerHTML={{ __html: text }} />
                {overflow ? (
                    <span
                        className={`${addonClass} ${overflowLoading ? styles.overflowLoading : ''}`}
                        ref={addonRef}
                        onClick={handleMoreClick}>
                        {!isVideoShare && (
                            <WxLaunchApp
                                launchType={'app'}
                                launchAppClick={() => {
                                    handleMoreClick(true, false, false);
                                }}
                                schemeLink={schemeLink}
                                launchAppFail={() => {
                                    handleMoreClick(false, true, true);
                                }}
                            />
                        )}
                        展开
                    </span>
                ) : null}
            </div>
        </div>
    );
};

Text.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Text);
